(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-bundle-product-info-new-two"] && !Shopify.designMode) return;
  try {
    
          const containers = document.querySelectorAll('.mpv1-ugc-videos');    

          containers.forEach((container) => {
            const items = container.querySelectorAll('.mpv1-ugc-videos__item');

            items.forEach((item) => {
              const video = item.querySelector('.mpv1-ugc-videos__video');
              const playBtn = item.querySelector('.mpv1-ugc-videos__play-btn');
              const muteBtn = item.querySelector('.mpv1-ugc-videos__mute-btn');
              const poster = item.querySelector('.mpv1-ugc-videos__poster');

              if (!video || !playBtn || !muteBtn) return;

              video.muted = false;

              const iconUnmuted = muteBtn.querySelector('.mpv1-ugc-videos__icon-unmuted');
              const iconMuted = muteBtn.querySelector('.mpv1-ugc-videos__icon-muted');

              function updateMuteIcon() {
                if (video.muted) {
                  iconUnmuted.hidden = true;
                  iconMuted.hidden = false;
                } else {
                  iconUnmuted.hidden = false;
                  iconMuted.hidden = true;
                }
              }

              updateMuteIcon();

              playBtn.addEventListener('click', () => {
                const allItems = container.querySelectorAll('.mpv1-ugc-videos__item');

                allItems.forEach((otherItem) => {
                  const otherVideo = otherItem.querySelector('.mpv1-ugc-videos__video');
                  const otherPlay = otherItem.querySelector('.mpv1-ugc-videos__play-btn');
                  const otherPoster = otherItem.querySelector('.mpv1-ugc-videos__poster');

                  if (otherVideo && otherVideo !== video) {
                    otherVideo.pause();

                    if (otherPlay) otherPlay.style.opacity = '1';
                    if (otherPoster) {
                      otherPoster.classList.remove('mpv1-ugc-videos__poster--hidden');
                    }
                  }
                });

                if (video.paused) {
                  video.play();
                  playBtn.style.opacity = '0';

                  if (poster) {
                    poster.classList.add('mpv1-ugc-videos__poster--hidden');
                  }
                } else {
                  video.pause();
                  playBtn.style.opacity = '1';

                  if (poster) {
                    poster.classList.remove('mpv1-ugc-videos__poster--hidden');
                  }
                }
              });

              muteBtn.addEventListener('click', () => {
                video.muted = !video.muted;
                updateMuteIcon();
              });
            });
          });
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-bundle-product-info-new"] && !Shopify.designMode) return;
  try {
    
          const containers = document.querySelectorAll('.mpv1-ugc-videos');    

          containers.forEach((container) => {
            const items = container.querySelectorAll('.mpv1-ugc-videos__item');

            items.forEach((item) => {
              const video = item.querySelector('.mpv1-ugc-videos__video');
              const playBtn = item.querySelector('.mpv1-ugc-videos__play-btn');
              const muteBtn = item.querySelector('.mpv1-ugc-videos__mute-btn');
              const poster = item.querySelector('.mpv1-ugc-videos__poster');

              if (!video || !playBtn || !muteBtn) return;

              video.muted = false;

              const iconUnmuted = muteBtn.querySelector('.mpv1-ugc-videos__icon-unmuted');
              const iconMuted = muteBtn.querySelector('.mpv1-ugc-videos__icon-muted');

              function updateMuteIcon() {
                if (video.muted) {
                  iconUnmuted.hidden = true;
                  iconMuted.hidden = false;
                } else {
                  iconUnmuted.hidden = false;
                  iconMuted.hidden = true;
                }
              }

              updateMuteIcon();

              playBtn.addEventListener('click', () => {
                const allItems = container.querySelectorAll('.mpv1-ugc-videos__item');

                allItems.forEach((otherItem) => {
                  const otherVideo = otherItem.querySelector('.mpv1-ugc-videos__video');
                  const otherPlay = otherItem.querySelector('.mpv1-ugc-videos__play-btn');
                  const otherPoster = otherItem.querySelector('.mpv1-ugc-videos__poster');

                  if (otherVideo && otherVideo !== video) {
                    otherVideo.pause();

                    if (otherPlay) otherPlay.style.opacity = '1';
                    if (otherPoster) {
                      otherPoster.classList.remove('mpv1-ugc-videos__poster--hidden');
                    }
                  }
                });

                if (video.paused) {
                  video.play();
                  playBtn.style.opacity = '0';

                  if (poster) {
                    poster.classList.add('mpv1-ugc-videos__poster--hidden');
                  }
                } else {
                  video.pause();
                  playBtn.style.opacity = '1';

                  if (poster) {
                    poster.classList.remove('mpv1-ugc-videos__poster--hidden');
                  }
                }
              });

              muteBtn.addEventListener('click', () => {
                video.muted = !video.muted;
                updateMuteIcon();
              });
            });
          });
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function() {

    // Add "Our Products" accordion to mobile menu drawer
    function addMobileShopAccordion() {
      if (window.innerWidth > 989) return; // Only on mobile
      
      const template = document.getElementById('mobile-shop-accordion-template');
      if (!template) return;
      
      // Try multiple selectors for menu drawer - also check inside header-drawer
      const headerDrawer = document.querySelector('header-drawer');
      const menuDrawer = (headerDrawer && headerDrawer.querySelector('.menu-drawer__inner')) ||
                         document.querySelector('.menu-drawer__inner') || 
                         document.querySelector('.menu-drawer') ||
                         document.querySelector('menu-drawer') ||
                         document.querySelector('[id*="menu-drawer"]') ||
                         (headerDrawer && headerDrawer.shadowRoot && headerDrawer.shadowRoot.querySelector('.menu-drawer__inner'));
      
      if (!menuDrawer) return;
      
      if (menuDrawer.querySelector('.mobile-shop-accordion')) return; // Already added
      
      const accordion = template.querySelector('.mobile-shop-accordion').cloneNode(true);
      
      // Try multiple selectors for menu list
      const menuList = menuDrawer.querySelector('ul.list-menu') || 
                       menuDrawer.querySelector('.list-menu') ||
                       menuDrawer.querySelector('nav ul') ||
                       menuDrawer.querySelector('.menu-drawer__menu ul') ||
                       menuDrawer.querySelector('ul') ||
                       menuDrawer.querySelector('.menu-drawer__menu');
      
      if (menuList) {
        if (menuList.firstChild) {
          menuList.insertBefore(accordion, menuList.firstChild);
        } else {
          menuList.appendChild(accordion);
        }
      }
    }
    
    // Try to add accordion
    function tryAddAccordion() {
      if (window.innerWidth <= 989) {
        addMobileShopAccordion();
      }
    }
    
    // Run immediately and with delays
    tryAddAccordion();
    setTimeout(tryAddAccordion, 100);
    setTimeout(tryAddAccordion, 500);
    setTimeout(tryAddAccordion, 1000);
    setTimeout(tryAddAccordion, 2000);
    
    // Also run after window load
    if (document.readyState === 'loading') {
      window.addEventListener('load', function() {
        setTimeout(tryAddAccordion, 100);
        setTimeout(tryAddAccordion, 500);
      });
    } else {
      setTimeout(tryAddAccordion, 100);
      setTimeout(tryAddAccordion, 500);
    }
    
    // Watch for menu button clicks
    document.addEventListener('click', function(e) {
      if (e.target.closest('header-drawer') || 
          e.target.closest('.header__icon--menu') || 
          e.target.closest('[aria-controls*="menu"]') ||
          e.target.closest('button[aria-label*="menu" i]') ||
          e.target.closest('[id*="Details-menu"]')) {
        setTimeout(tryAddAccordion, 100);
        setTimeout(tryAddAccordion, 300);
        setTimeout(tryAddAccordion, 600);
        setTimeout(tryAddAccordion, 1000);
      }
    });
    
    // Watch for menu drawer being added or opened
    const menuObserver = new MutationObserver(function(mutations) {
      if (window.innerWidth <= 989) {
        // Check if menu drawer was added or opened
        const menuDrawer = document.querySelector('.menu-drawer__inner') || 
                          document.querySelector('.menu-drawer') ||
                          document.querySelector('menu-drawer');
        if (menuDrawer && menuDrawer.offsetParent !== null) {
          addMobileShopAccordion();
        }
      }
    });
    
    if (document.body) {
      menuObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'aria-hidden', 'open']
      });
    }
    
    // Also listen for custom events that might be fired when drawer opens
    document.addEventListener('shopify:menu:open', tryAddAccordion);
    document.addEventListener('menu:open', tryAddAccordion);

    // Ensure only Our Products accordion is active when open
    document.addEventListener('click', function(e) {
      const accordion = e.target.closest('.mobile-shop-accordion');
      if (accordion) {
        // Remove active state from other menu items
        const menuDrawer = document.querySelector('.menu-drawer__inner') || document.querySelector('.menu-drawer');
        if (menuDrawer) {
          const otherMenuItems = menuDrawer.querySelectorAll('.menu-drawer__menu-item--active');
          otherMenuItems.forEach(function(item) {
            if (!item.closest('.mobile-shop-accordion')) {
              item.classList.remove('menu-drawer__menu-item--active');
            }
          });
        }
      }
    });

    // Improved mega menu hover behavior - only after page is fully loaded
    function initMegaMenuHover() {
      const megaMenuWrapper = document.querySelector('.shop-mega-menu-wrapper');
      const megaMenu = document.querySelector('.shop-mega-menu');
      const header = document.querySelector('.section-header');
      
      if (!megaMenuWrapper || !megaMenu || !header) {
        // Retry if elements not ready yet
        setTimeout(initMegaMenuHover, 100);
        return;
      }
      
      // Wait for images in mega menu to load
      const images = megaMenu.querySelectorAll('img');
      let imagesLoaded = 0;
      const totalImages = images.length;
      
      function checkImagesAndInit() {
        if (imagesLoaded >= totalImages) {
          setupHoverHandlers();
        }
      }
      
      if (totalImages > 0) {
        images.forEach(function(img) {
          if (img.complete) {
            imagesLoaded++;
            checkImagesAndInit();
          } else {
            img.addEventListener('load', function() {
              imagesLoaded++;
              checkImagesAndInit();
            });
            img.addEventListener('error', function() {
              imagesLoaded++;
              checkImagesAndInit();
            });
          }
        });
      } else {
        setupHoverHandlers();
      }
      
      function setupHoverHandlers() {
        
        let hoverTimeout;
        let isMenuHovered = false;
        let isWrapperHovered = false;
        let isInitialized = true;
        
        function showMenu() {
          if (!isInitialized) return;
          clearTimeout(hoverTimeout);
          
          megaMenu.style.opacity = '1';
          megaMenu.style.visibility = 'visible';
          megaMenu.style.transform = 'translateY(0)';
          megaMenu.style.pointerEvents = 'auto';
          isMenuHovered = true;
        }
        
        function hideMenu() {
          hoverTimeout = setTimeout(function() {
            if (!isMenuHovered && !isWrapperHovered) {
              megaMenu.style.opacity = '0';
              megaMenu.style.visibility = 'hidden';
              megaMenu.style.transform = 'translateY(-10px)';
              megaMenu.style.pointerEvents = 'none';
            }
          }, 200);
        }
        
        // Handle wrapper hover
        megaMenuWrapper.addEventListener('mouseenter', function() {
          if (!isInitialized) return;
          isWrapperHovered = true;
          showMenu();
        });
        
        megaMenuWrapper.addEventListener('mouseleave', function() {
          isWrapperHovered = false;
          hideMenu();
        });
        
        // Handle menu hover
        megaMenu.addEventListener('mouseenter', function() {
          if (!isInitialized) return;
          isMenuHovered = true;
          showMenu();
        });
        
        megaMenu.addEventListener('mouseleave', function() {
          isMenuHovered = false;
          hideMenu();
        });
      
        // Close menu on scroll down
        let lastScrollY = window.scrollY;
        window.addEventListener('scroll', function() {
          if (!isInitialized) return;
          const currentScrollY = window.scrollY;
          if (currentScrollY > lastScrollY && (isMenuHovered || isWrapperHovered)) {
            // Scrolling down - close menu
            isMenuHovered = false;
            isWrapperHovered = false;
            clearTimeout(hoverTimeout);
            megaMenu.style.opacity = '0';
            megaMenu.style.visibility = 'hidden';
            megaMenu.style.transform = 'translateY(-10px)';
            megaMenu.style.pointerEvents = 'none';
          }
          lastScrollY = currentScrollY;
        }, { passive: true });
      }
    }
    
    // Initialize after page is completely loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        window.addEventListener('load', function() {
          setTimeout(initMegaMenuHover, 100);
        });
      });
    } else {
      if (document.readyState === 'complete') {
        setTimeout(initMegaMenuHover, 100);
      } else {
        window.addEventListener('load', function() {
          setTimeout(initMegaMenuHover, 100);
        });
      }
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-health-expert"] && !Shopify.designMode) return;
  try {
    
<!-- Optional JS if needed -->

  } catch(e) { console.error(e); }
})();
})();
